<template>
  <div id="page-pref-detail">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="6em"
    >
      <el-row>
        <el-form-item prop="supplierId" label="合作商">
          <filter-businessline-partner
            :value.sync="supplierId"
            :code.sync="searchForm.supplierCode"
            :businessLine="2"
            required
          />
        </el-form-item>
        <el-form-item prop="workType" label="工种">
          <filter-job-type :value.sync="searchForm.workType" />
        </el-form-item>
        <el-form-item label="考核时间">
          <filter-date-range :value.sync="dateRange" clearable />
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="fetchData(true)" :loading="isLoading">查询</el-button>
          <el-button @click="exportDetail">导出明细</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <!-- 列表 -->
    <el-table stripe :data="dataList" v-loading="isLoading">
      <el-table-column
        v-for="item in tableColumn"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width || ''"
      >
        <template slot-scope="scoped">
          <template v-if="item.filter">
            {{ item.filter(scoped.row) }}
          </template>
          <template v-else-if="item.subProp">
            <detail-info v-if="scoped.row[item.prop]" :info="scoped.row[item.prop]" />
            <span v-else>--</span>
          </template>
          <template v-else>
            {{ scoped.row[item.prop] }}
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        background
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/utils'
import pagination from '@/mixins/pagination'
import qs from 'qs'
import { api } from '@/api/apiList'
import DetailInfo from './detail-info.vue'

const defLabels = [
  {
    label: '合作商',
    prop: 'supplierName',
    filter: row => {
      return `${row.supplierName}（${row.supplierCode}）`
    },
    width: 200,
  },
  {
    label: '用工类型',
    prop: 'userTypeDesc',
  },
  {
    label: 'Region',
    prop: 'regionIdName',
    width: 120,
  },
  {
    label: '工种',
    prop: 'workTypeDesc',
  },
]
export default {
  mixins: [pagination],

  components: {
    DetailInfo,
  },

  data() {
    return {
      isLoading: false,
      dataList: [],
      dateRange: [],
      pageSize: 10,
      totalAmount: 0,
      detailData: {},
      dynamicColumn: [],
      tableColumn: [],
      supplierId: '',
      searchForm: {
        supplierCode: '',
        workType: '',
        startDate: '',
        endDate: '',
      },
    }
  },

  created() {
    this.initPagination('fetchData', false)
  },

  methods: {
    // 列表
    fetchData(init = false) {
      if (init) this.pageNo = 1
      const params = {
        ...this.searchForm,
        startDate: dateFormat(this.dateRange[0]),
        endDate: dateFormat(this.dateRange[1]),
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      this.isLoading = true
      this.fetch
        .get('performanceList', { params })
        .then(res => {
          const { totalCount = 0, list = [] } = res.data
          this.dataList = (list || []).map(item => {
            Object.keys(item.actionDetailModelMap).forEach(dateKey => {
              item[dateKey] = item.actionDetailModelMap[dateKey]
            })
            return item
          })
          this.processData()
          this.totalAmount = totalCount
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    // 导出
    exportDetail() {
      const params = {
        ...this.searchForm,
        startDate: dateFormat(this.dateRange[0]),
        endDate: dateFormat(this.dateRange[1]),
        pageNo: 1,
        pageSize: 1000000,
      }
      window.open(`${api.exportPerformanceList}?${qs.stringify(params)}`)
    },

    // 补齐表头
    processData() {
      let endDate = new Date()
      const dateLabelList = []
      // 默认最近7天
      let span = 7
      if (this.dateRange && this.dateRange[0]) {
        // 获取天数
        span =
          (new Date(this.dateRange[1]).getTime() - new Date(this.dateRange[0]).getTime()) /
            (3600 * 24 * 1000) +
          1
        endDate = new Date(this.dateRange[1])
        endDate.setDate(endDate.getDate() + 1)
      }
      for (let i = 1; i <= span; i++) {
        dateLabelList.push(dateFormat(endDate.setDate(endDate.getDate() - 1)))
      }
      this.dynamicColumn = []
      dateLabelList.sort().forEach(item => {
        this.dynamicColumn.push({
          label: item,
          prop: item,
          width: 100,
          subProp: true,
        })
      })
      this.tableColumn = [...defLabels, ...this.dynamicColumn]
    },
  },
}
</script>
